// export const baseUrl = 'http://localhost:4000'
export const baseUrl = "https://pool-vine-backend.herokuapp.com";
export const ClientBaseURL = "https://trustcoin.world";
// export const ClientBaseURL = "http://localhost:3000";
// https://ico-dashboar.netlify.app/
